<template>
    <div>
        仓库管理系统的home页面
    </div>
</template>

<script>
  export default {
    name: "Home",
    data: () => ({
      isShowConfirm:true
    }),
    watch: {},
    computed: {},
    methods: {},
    created() {
    },
    mounted() {
    },
  }
</script>

<style scoped>

</style>